import {Repository} from "../Core/Repository.js";
import {Schema} from "../Infrastructure/Server/Schema";
import {CustomObject} from "../Object/CustomObject";
import {MapSVGMap} from "./Map";

export class MapsRepository extends Repository {

    path = 'maps/';

    constructor() {
        super('map', 'maps');
    }

    encodeData(params: any): {[key: string]: any} {

        let data: {[key: string]: any} = {};
        data.options = JSON.stringify(params.options);

        // Apache mod_sec blocks requests with the following words:
        // table, select, database. Encode those words to decode them later in PHP to prevent blocking:
        data.options = data.options.replace(/select/g,"!mapsvg-encoded-slct");
        data.options = data.options.replace(/table/g,"!mapsvg-encoded-tbl");
        data.options = data.options.replace(/database/g,"!mapsvg-encoded-db");
        data.options = data.options.replace(/varchar/g,"!mapsvg-encoded-vc");

        data.id = params.id;
        data.title = params.title;

        return data;
    }

    decodeData(dataJSON: string|{[key: string]: any}): {[key: string]: any} {

        let data;

        if(typeof dataJSON === 'string'){
            data = JSON.parse(dataJSON);
        } else {
            data = dataJSON;
        }


        return data;
    }

    copy(id: number, title: string): JQueryDeferred<any> {

        let defer = jQuery.Deferred();
        defer.promise();

        let data = {options: {title: title}};

        this.server.post(this.path + id + '/copy', this.encodeData(data)).done((response: string) => {
            var data = this.decodeData(response);
            this.objects.clear();
            this.events.trigger('loaded');
            this.events.trigger('cleared');
            defer.resolve(data.map);
        }).fail(()=>{ defer.reject(); });

        return defer;
    }

    createFromV2(object: any){
        let defer = jQuery.Deferred();
        defer.promise();

        let data = {};
        data[this.objectNameSingle] = this.encodeData(object);

        this.server.post(this.path+'/createFromV2', data).done((response: any) => {
            let data = this.decodeData(response);
            let object = data[this.objectNameSingle];
            this.objects.push(object);
            defer.resolve(object);
            this.events.trigger('created', this, [object]);
        }).fail(()=>{
            defer.reject();
        });

        return defer;
    }

}